
const ServicesHero = () => {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/0623335ebbfadcca5c41ce69a2412dc0.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-6">
            Comprehensive Chemical Services
          </h1>
          <p className="text-xl max-w-3xl mx-auto leading-relaxed">
            From advanced analysis and chemical supply to customized solutions and field challenge resolution, 
            Golden Black delivers complete service excellence for the oil and gas industry.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
